import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { getData } from "../../../utils/api";
import { RoleId, Select2Data } from "../../../utils/common";
library.add(fas);

const TrakingId = (props) => {
  const { postData, user } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm();

  const [deliveryBoys, setDeliveryBoys] = useState([]);

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("tracking_id", data?.tracking_id);
      finalData.append("dispatch_company", data?.dispatch_company);
      const response = await postData(
        `/admin/orders/product-order/traking-id/${props?.show}`,
        finalData,
      );

      if (response?.success) {
        reset();
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const GetAllDeliveryBoys = async () => {
    if (user && user?.role_id === RoleId.Vendor) {
      const response = await getData(`/common/masters/delivery-boys`);
      if (response?.success) {
        setDeliveryBoys(await Select2Data(response?.data, "delivery_boy_id"));
      }
    }
  };

  useEffect(() => {
    GetAllDeliveryBoys();
  }, [props.show]);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Enter Tracking Id
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <Form onSubmit={() => handleSubmit(onSubmit)} role="form"> */}
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
          <Row className="">


            <Col md={6}>
              <Form.Control
                type="text"
                placeholder="Enter Tracking Id"
                {...register("tracking_id", {
                  required: "Tracking Id is required",
                })}
                isInvalid={errors?.tracking_id}
              />
              {errors.tracking_id && (
                <div className="invalid-feedback">
                  {errors.tracking_id.message}
                </div>
              )}
            </Col>

            <Col md={6}>
              <Form.Control
                type="text"
                placeholder="Enter dispatch company"
                {...register("dispatch_company", {
                  required: "dispatch_company is required",
                })}
                isInvalid={errors?.dispatch_company}
              />
              {errors.dispatch_company && (
                <div className="invalid-feedback">
                  {errors.dispatch_company.message}
                </div>
              )}
            </Col>

            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link>
                  <CancelButton
                    name={"Cancel"}
                    handleClose={props.handleClose}
                  />
                </Link>

                <SaveButton
                  name={"save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </div>
            </Row>
          </Row>


        </Form>
      </Modal.Body>
    </Modal >

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default TrakingId;
